const phpSessIdUpdate = new CustomEvent('phpSessIdUpdate');

const lastPhpSessId = window.localStorage.getItem('lastPhpSessId');
const phpSessId = window.localStorage.getItem('phpSessId');
if (lastPhpSessId && lastPhpSessId !== phpSessId) {
  window.dispatchEvent(phpSessIdUpdate);
}
window.localStorage.setItem('lastPhpSessId', phpSessId);
